import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>Packimpex Ltd., Brunnmattstrasse 5, 3174 Thörishaus/Bern, Switzerland</p>
      <p>You received this request because you appear in our supplier database.<br/>By submitting your quote you accept our <a href="https://www.packimpex.com/sites/default/files/2023-02/Packimpex-Germany-Terms-and-Conditions-Moving-Services.pdf" target="_blank" rel="noopener noreferrer">terms &amp; conditions</a>.</p>
    </footer>
  );
}
